export default class FeatureFlag {
    constructor(readonly id: string, readonly value: unknown) {}
}
